module.exports = __webpack_public_path__ + "img/logo.b1b22baa.png";